import React, { Component } from 'react';
class MessagePopup extends Component {
  constructor() {
    super();
    this.state = {
    };
  }


  componentDidMount() {

  }

  render() {
    return (
      <div class="modal fade" id="myModal" role="dialog">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
            <h4 class="modal-title" id="page_titlte">{this.props.title}</h4>
              <button type="button" class="close" data-dismiss="modal" onClick={this.props.close_popup_view}>&times;</button>
            </div>
            <div class="modal-body">


            <div class="chat-body chat-body-2">
             <p>{this.props.message}</p>
            </div>
            </div>
            {/*
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            </div>
            */}
          </div>
        </div>
      </div>
    );
  }
}

export default MessagePopup;
